<template>
    <div class="row pb-5">
        <div class="col-md-12 card-wrapper">
            <div class="card" v-if="showWorkflowList">
                <div class="card-header crm-modal-header hpx-50 d-flex align-items-center">{{$ml.get('WORKFLOW_LIST')}}</div>
                <div class="card-body bg-light color-gray">
                    <p class="text-dark font-15 mb-4">{{$ml.get('WORKFLOW_DESC')}}</p>
                    <button class="btn bg-new-primary btn-lg" @click="newWorkflowBtn()">{{$ml.get('NEW_WORKFLOW')}}</button>
                    <div class="mt-4 px-2">
                        <grid v-if="windowWidth>maxMobilSize" :data="gridData" @editContact="getContactData($event)" @sortedData="getSortedData($event)" :tableConfigVisible="tableConfigVisible" :columns="gridColumns" :permissions="permissions" :user="user" :users="users" :page="pageIs" @deleteWorkflowSection="deleteWorkflowSection($event)"></grid>
                        <gridMobil v-else :data="gridData" @editContact="getContactData($event)" @sortedData="getSortedData($event)" :tableConfigVisible="tableConfigVisible" :columns="gridColumns" :permissions="permissions" :user="user" :users="users" :page="pageIs"></gridMobil>
                    </div>
                </div>
            </div>
            <div class="card" v-else>
                <div class="card-header crm-modal-header hpx-50 d-flex align-items-center">{{$ml.get('NEW_WORKFLOW')}}</div>
                <div class="card-body bg-light color-gray">
                    <p class="text-dark font-15">{{$ml.get('COMPLETE_WORKFLOW_STEPS_AND_AUTOMATE_MANUAL_WORK')}}</p>
                    
                    <div id="accordion" class="py-2">
                        <!-- İş Akışı Kuralı Belirle -->
                        <div class="card mt-2">
                            <div class="card-header d-flex align-items-center card-header-section" id="setWorkflowRules" data-target="#setWorkflowRulescollapse" aria-expanded="true" aria-controls="setWorkflowRulescollapse" style="cursor: pointer;">
                                <h6 class="px-3 p-2 card-number">1</h6>
                                <h5 class="ml-4 py-2 mt-2 card-header-text">
                                    {{$ml.get('SET_WORKFLOW_RULES')}}
                                </h5>
                            </div>
                            <div id="setWorkflowRulescollapse" class="show" aria-labelledby="setWorkflowRules" data-parent="#accordion">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div>
                                                <label class="new-label">{{$ml.get('RELATED_MODULE')}}
                                                    <v-popover class="d-inline-block ml-1" style="cursor:pointer;">
                                                    <i class="fa fa-info-circle tooltip-target b3" ></i>
                                                        <template #popover>
                                                            <p><i class="fa fa-info-circle fa-3x"></i></p>
                                                            <p>
                                                            {{$ml.get('PERSON_TIMEZONE_INFO')}}
                                                            </p>
                                                            <a v-close-popover class="btn bg-new-primary text-white">{{$ml.get('COMPLETE')}}</a>
                                                        </template>
                                                    </v-popover>
                                                </label>
                                                <!-- ******** Modül Kısmı ******* -->
                                                <select id="relatedModule" @change="updateRelatedModule()" v-model="relatedModule" class="new-input bg-white mb-2">
                                                    <option disabled value="">{{$ml.get('SELECT_MODULE')}}</option>
                                                    <option value="deals">{{$ml.get('OPPORTUNITIES')}}</option>
                                                    <option value="organizations">{{$ml.get('COMPAINES')}}</option>
                                                    <option value="activities">{{$ml.get('ACTIVITIES')}}</option>
                                                    <option value="contacts">{{$ml.get('PERSONS')}}</option>
                                                    <option value="products">{{$ml.get('PRODUCTS')}}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div>
                                                <label class="new-label">{{$ml.get('RULE_NAME')}}</label>
                                                <input type="text" v-model="ruleName" class="new-input mb-2" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-md-12">
                                            <div>
                                                <label class="new-label">{{$ml.get('DESCRIPTION')}}</label>
                                                <textarea v-model="description" class="new-textarea w-100 mb-2" cols="30" rows="8"></textarea> 
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-4">
                                        <div class="col-md-12 text-right">
                                            <button class="btn bg-new-primary btn-lg w-150p" id="proceedToStep2Btn" @click="nextToStep2()">{{$ml.get('PROCEED_V2')}}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Tetiklenme Durumu - Ne zaman çalışacak? -->
                        <div class="card mt-3" id="whenWillTheWorkflowStartSection" style="pointer-events: none; opacity: 0.5;">
                            <div class="card-header d-flex align-items-center card-header-section" id="whenWillTheWorkflowStart" data-target="#whenWillTheWorkflowStartcollapse" aria-expanded="true" aria-controls="whenWillTheWorkflowStartcollapse" style="cursor: pointer;">
                                <h6 class="px-3 p-2 card-number">2</h6>
                                <h5 class="ml-4 py-2 mt-2 card-header-text">
                                    {{$ml.get('TRIGGER_WHEN_WILL_THE_WORKFLOW_START')}}
                                </h5>
                            </div>
                            <div id="whenWillTheWorkflowStartcollapse" class="collapse" aria-labelledby="whenWillTheWorkflowStart" data-parent="#accordion">
                                <div class="card-body">
                                    <div>
                                        <input type="radio" id="create" value="create" v-model="picked">
                                        <label class="ml-2 mt-2 text-dark" for="create">{{$ml.get('ON_RECORD_CREATION')}}</label>
                                    </div>
                                    <div>
                                        <input type="radio" id="update" value="update" v-model="picked">
                                        <label class="ml-2 mt-2 text-dark" for="update">{{$ml.get('ON_RECORD_UPDATE')}}</label>
                                    </div>
                                    <div>
                                        <input type="radio" id="always" value="always" v-model="picked">
                                        <label class="ml-2 mt-2 mb-4 text-dark" for="always">{{$ml.get('ON_RECORD_CREATION_OR_UPDATE')}}</label>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                        <!-- Koşul Belirleme - Hangi koşullara göre çalışacak? -->
                        <div class="card mt-3" id="howWillTheWorkflowWorkSection" style="pointer-events: none; opacity: 0.5;">
                            <div class="card-header d-flex align-items-center card-header-section" id="howWillTheWorkflowWork" data-target="#howWillTheWorkflowWorkcollapse" aria-expanded="true" aria-controls="howWillTheWorkflowWorkcollapse" style="cursor: pointer;">
                                <h6 class="px-3 p-2 card-number">3</h6>
                                <h5 class="ml-4 py-2 mt-2 card-header-text">
                                    {{$ml.get('DEFINE_CONDITIONS_HOW_WILL_THE_WORKFLOW_WORK')}}
                                </h5>
                            </div>
                            <div id="howWillTheWorkflowWorkcollapse" class="collapse" aria-labelledby="howWillTheWorkflowWork" data-parent="#accordion">
                                <div class="card-body">
                                    <div>
                                        <input type="radio" id="setCondition" value="setCondition" v-model="pickedCondition">
                                        <label class="ml-2 mt-2 text-dark" for="setCondition">{{$ml.get('SET_CONDITIONS')}}</label>
                                        <div id="mqBuilderWorkflow" style="display: none;">
                                            <mqBuilderWorkflow ref="mqBuilder" @changeTitle="ChangeT($event)" :updateWorkflow='updateWorkflowItem' @searchInput='searchInput($event)' @dependentOnTheForthSection="dependentOnTheForthArea"></mqBuilderWorkflow>
                                        </div>
                                    </div>
                                    <div>
                                        <input type="radio" id="applyWithoutCondition" value="applyWithoutCondition" v-model="pickedCondition">
                                        <label class="ml-2 mt-2 mb-4 text-dark" for="applyWithoutCondition">{{$ml.get('APPLY_WITHOUT_CONDITION')}}</label>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                        <!-- Aksiyon Belirle - Ne yapılacak? -->
                        <div class="card mt-3" id="decideActionSection" style="pointer-events: none; opacity: 0.5;">
                            <div class="card-header d-flex align-items-center card-header-section" id="decideAction" data-target="#decideActioncollapse" aria-expanded="true" aria-controls="decideActioncollapse" style="cursor: pointer;">
                                <h6 class="px-3 p-2 card-number">4</h6>
                                <h5 class="ml-4 py-2 mt-2 card-header-text">
                                    {{$ml.get('SET_ACTION_WHAT_WILL_BE_DONE')}}
                                </h5>
                            </div>
                            <div id="decideActioncollapse" class="collapse" aria-labelledby="decideAction" data-parent="#accordion">
                                <div class="card-body py-4">
                                    
                                    <div v-if="actionSummary">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <ul class="actionSummaryList">
                                                <li><span>{{$ml.get('ACTION_METHOD')}}: </span>{{create_activity_val}}</li>
                                                <li><span>{{$ml.get('ACTION_NAME_V2')}}: </span>{{actionName}}</li>
                                                <li><span>{{$ml.get('ACTION_TIMING')}}: </span>{{activityDateAction_val}}</li>
                                            </ul>
                                            <div class="summaryIcons">
                                                <i class="fas fa-pen" data-toggle="modal" data-target="#addAction" ></i>
                                                <i class="fas fa-trash" data-toggle="modal" data-target="#deleteActionID"></i>
                                            </div>
                                            <div class="modal fade" id="deleteActionID" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                                <div class="modal-dialog modal-dialog-centered" role="document">
                                                  <div class="modal-content d-flex align-items-center justify-content-center px-2 py-3">
                                                    <div class="modal-body text-center">
                                                        <i class="fas fa-trash fa-3x" style="background: #FF0000; color: #fff; padding: 1.5rem; border-radius: 50%;"></i>
                                                        <h2 class="my-3" style="color:#47495A;">{{$ml.get('DELETE_THE_ACTION')}}</h2>
                                                        <p style="color: #53565E; font-size: 16px;">{{$ml.get('ACTION_WILL_BE_DELETED_DO_YOU_CONFIRM?')}}</p>
                                                    </div>
                                                    <div class="modal-footer">
                                                      <button type="button" class="btn bg-transparent btn-lg mr-2" style="font-weight: 500; font-size: 16px;" data-dismiss="modal">{{$ml.get('CANCEL')}}</button>
                                                      <button type="button" class="btn btn-lg" style="background: #FF0000; color: #fff; font-weight: 600; font-size: 16px;" data-dismiss="modal" @click="deleteAction">{{$ml.get('YES')}}</button>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div class="row d-flex align-items-center">
                                            <div class="col-md-6">
                                                <p class="font-15 text-dark">{{$ml.get('SET_AN_ACTION_TO_COMPLETE_THE_WORKFLOW')}}</p>
                                            </div>
                                            <div class="col-md-6  text-right">
                                                <div class="mx-2 addBtn" data-toggle="modal" data-target="#addAction" >
                                                    <button type="button" class="btn bg-new-primary f-14 h-100">
                                                        <i class="fa fa-plus f-14 mr-1"></i> {{$ml.get('CREATE_ACTION')}}
                                                    </button>
                                                </div>
                                            </div>
                                            <!-- Deneme Create Action -->
                                            <div class="mx-2 addBtn" style="display: none;">
                                                <button type="button" disabled class="btn bg-new-primary f-14 h-100">
                                                    <i class="fa fa-plus f-14 mr-1"></i> {{$ml.get('CREATE_ACTION')}}
                                                </button>
                                            </div>
                                            
                                        </div>
                                    </div>
                                
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer crm-modal-footer text-right py-3">
                    <div v-if="isUpdateMode==true">
                        <button class="btn bg-new-primary w-150p btn-lg mr-2" @click="updateF()">{{$ml.get('SAVE')}}</button>
                        <button class="btn btn-lg bg-transparent" @click="goBackToWorkflowListBtn()">{{$ml.get('CANCEL')}}</button>
                    </div>
                    <div v-else>
                        <button class="btn bg-new-primary w-150p btn-lg mr-2" id="saveBtn" disabled @click="createF()">{{$ml.get('SAVE')}}</button>
                        <button class="btn btn-lg bg-transparent" @click="goBackToWorkflowListBtn()">{{$ml.get('CANCEL')}}</button>
                    </div>
                    
                </div>
            </div>
        </div>
        <!-- Aksiyon Oluştur -->
        <div class="modal fade" id="addAction" style="transform: scale(1)" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" id="closeActionBtn"  role="document" style="max-width:750px!important">
                <div class="modal-content">
                    <!-- Aksiyon Kısmını Göster -->
                    <div v-if="showActionSection">
                        <div class="modal-header py-2 pt-3" style="background: #162C4D;">
                            <h5 class="text-white">{{$ml.get('CREATE_ACTION_V2')}}</h5>
                            <button type="button" class="close pb-3 pt-2" style="color: #8092AB;" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true" class="font-40">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <p style="color: #2E323C; font-size: 15px;">{{$ml.get('DEFINE_NAME_AND_THE_METHOD_OF_THE_ACTION')}}</p>
                            <div class="row">
                                <div class="col-md-6">
                                    <label class="new-label">{{$ml.get('ACTION_NAME')}}</label>
                                    <input type="text" v-model="actionName" class="new-input mb-2" />
                                </div>
                            </div>
                            <hr>
                            <div class="row">
                                <div class="col-md-12">
                                    <label class="new-label mb-2 mt-0">{{$ml.get('SET_ACTIONS_TIMING')}}</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="radio-btn-groups-wrapper col-md-4">
                                    <input type="radio" class="radio-btn-group" name="radioButtonTest" v-model="radioInstant" value="1" id="button1" />
                                    <label for="button1" id="instantBtnID" @click="instantBtn()">{{$ml.get('INSTANT')}}</label>
                                    <input type="radio" class="radio-btn-group" name="radioButtonTest" v-model="radioScheduled" value="2" id="button2" />
                                    <label for="button2" id="plannedDateBtnID" @click="plannedDateBtn()">{{$ml.get('SCHEDULED_DATE')}}</label>
                                </div>
                            </div>
                            <hr class="mb-1">
                            <div class="row" v-if="showInstantSection">
                                <!-- Tarih ayarları burada yapılmayacak -->
                            </div>
                            <div v-else-if="showPlannedDateSection">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div>
                                            <input type="radio" id="fromDecidedDate" @click="fromDecidedDateSection" value="fromDecidedDate" v-model="pickedActionRadioBtn">
                                            <label class="ml-2 mt-2 mb-4 text-dark" style="word-spacing: 1px;" for="fromDecidedDate">{{$ml.get('FOLLOWING_A_PREDEFINED_DATE')}}</label>
                                        </div>
                                        <!-- GÜN SAAT DAKİKA -->
                                        <div class="d-flex mt-0 mb-4" id="fromDecidedDateSectionID" style="pointer-events: none;">
                                            <div class="row d-flex align-items-center">
                                                <div class="col-sm-3">
                                                    <label class="new-label mt-4 font-family-bold">{{$ml.get('AFTER_THE_START_OF_WORKFLOW')}}</label>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="row d-flex align-items-center">
                                                        <div class="col-sm-3">
                                                            <label class="new-label mb-1">{{$ml.get('DAY')}}</label>
                                                            <input type="number" v-model="delayDay" placeholder="0" style="height: 34px;" class="new-input mb-2" />
                                                        </div>
                                                        <div class="col-sm-3">
                                                            <label class="new-label mb-1">{{$ml.get('HOUR')}}</label>
                                                            <input type="number" v-model="delayHour" placeholder="0" style="height: 34px;" class="new-input mb-2" />
                                                        </div>
                                                        <div class="col-sm-3">
                                                            <label class="new-label mb-1">{{$ml.get('MINUTE')}}</label>
                                                            <input type="number" v-model="delayMinute" placeholder="0" style="height: 34px;" class="new-input mb-2" />
                                                        </div>
                                                        <div class="col-sm-2">
                                                            <label class="new-label font-family-bold mt-sm-4">{{$ml.get('AFTER_WORKFLOW_ACTION')}}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="row">
                                            <div class="col-md-3">
                                                <input type="radio" id="decideDateHour" @click="decideDateHourSection"  value="decideDateHour" v-model="pickedActionRadioBtn">
                                                <label class="ml-2 mt-2 mb-4 text-dark" style="word-spacing: 1px;" for="decideDateHour">{{$ml.get('SET_DATE_TIME')}}</label>
                                            </div>
                                            <div class="row" id="decideDateHourSectionID" style="pointer-events: none;">
                                                <div class="col-md-4">
                                                    <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" id="activityDateAction" class="new-ctk" v-model="activityDateAction" format="YYYY-MM-DD" formatted="ll" :noLabel="true" :range="false" :onlyDate="true" :auto-close="true" :label="$ml.get('SET_DATE_TIME')"></vue-ctk-date-time-picker>
                                                </div>
                                                <div class="col-md-4 d-flex">
                                                    <label class="mr-2 mt-2 mb-1 text-dark">{{$ml.get('TIME_V2')}}</label>
                                                    <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" id="activityTimeAction" :label="$ml.get('TIME')" v-model="activityTimeAction" class="new-ctk" format="HH:mm" formatted="HH:mm" :noLabel="true" :range="false" :onlyTime="true"></vue-ctk-date-time-picker>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-3 mb-2">
                                    <div class="col-md-12">
                                        <div class="row d-flex align-items-center">
                                            <input class="ml-3" type="radio" id="radioModule" @click="radioModuleSection" value="radioModule" v-model="pickedActionRadioBtn">
                                            <div class="col-md-10" id="radioModuleSectionID" style="pointer-events: none;">
                                                <div class="row">
                                                    <div class="col-md-3">
                                                        <label class="new-label text-dark"  style="word-spacing: 1px;" for="radioModule">{{$ml.get('RIGHT_AFTER')}}</label>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <div v-if="this.relatedModule === 'organizations'">
                                                            <select id="" v-model="actionRelatedModule" class="new-input bg-white mb-2" style="height: 34px;">
                                                                <option selected disabled value="">{{$ml.get('SELECT')}}</option>
                                                                <option value="createdAt">{{$ml.get('CREATION_DATE')}}</option>CREATION_DATE
                                                                <option value="modifiedAt">{{$ml.get('DATE_OF_UPDATE')}}</option>
                                                            </select>
                                                        </div>
                                                        <div v-else-if="this.relatedModule === 'deals'">
                                                            <select id="" v-model="actionRelatedModule" class="new-input bg-white mb-2" style="height: 34px;">
                                                                <option selected disabled value="">{{$ml.get('SELECT')}}</option>
                                                                <option value="addDate">{{$ml.get('ADDITION_DATE')}}</option>
                                                                <option value="expectedDate">{{$ml.get('ESTIMATED_CLOSING')}}</option>
                                                                <option value="closedDate">{{$ml.get('CLOSING_DATE')}}</option>
                                                            </select>
                                                        </div>
                                                        <div v-else-if="this.relatedModule === 'activities'">
                                                            <select id="" v-model="actionRelatedModule" class="new-input bg-white mb-2" style="height: 34px;">
                                                                <option selected disabled value="">{{$ml.get('SELECT')}}</option>
                                                                <option value="dueDate">{{$ml.get('PLANNED_TIME')}}</option>
                                                                <option value="doneDate">{{$ml.get('COMPLETION_TIME')}}</option>
                                                                <option value="addDate">{{$ml.get('ADDITION_DATE')}}</option>
                                                            </select>
                                                        </div>
                                                        <div v-else-if="this.relatedModule === 'contacts'">
                                                            <select id="" v-model="actionRelatedModule" class="new-input bg-white mb-2" style="height: 34px;">
                                                                <option selected disabled value="">{{$ml.get('SELECT')}}</option>
                                                                <option value="dob">{{$ml.get('DATE_OF_BIRTH')}}</option>
                                                                <option value="wed_ann">{{$ml.get('WEDDING_ANNIVERSARY')}}</option>
                                                            </select>
                                                        </div>
                                                        <div v-else-if="this.relatedModule === 'products'">
                                                            <select id="" class="new-input bg-white mb-2" style="height: 34px;">
                                                                <option selected disabled value="">{{$ml.get('SELECT')}}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="actionMethodSection">
                                <div class="col-md-6">
                                    <label class="new-label">{{$ml.get('DEFINE_METHOD_OF_ACTION')}}</label>
                                    <select id="actionMethodSelection" v-model="actionMethodSelection" class="new-input bg-white mb-2">
                                        <option disabled value="">{{$ml.get('SELECT')}}</option>
                                        <option value="create_activity">{{$ml.get('CREATE_ACTIVITY')}}</option>
                                        <option value="create_deal">{{$ml.get('CREATE_DEAL')}}</option>
                                        <option value="create_process">{{$ml.get('CREATE_PROCESS')}}</option>
                                        <option>{{$ml.get('FIELD_UPDATE')}}</option>
                                        <option>{{$ml.get('SEND_EMAIL')}}</option>
                                        <option>{{$ml.get('RUN_WEBHOOK')}}</option>
                                        <option>{{$ml.get('RUN_PLUGIN')}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn bg-transparent mr-2" onclick="$('#addAction').modal('hide');" aria-label="Close" >{{$ml.get('CANCEL')}}</button>
                            <button type="button" v-if="showInstantSection === true || showPlannedDateSection === true" class="btn bg-new-primary btn-lg" @click="nextToActionMethod()">{{$ml.get('PROCEED_V2')}}</button>
                        </div>
                    </div>
                    <!-- Aktivite Oluştur -->
                    <div v-else-if="showActivitySection">
                        <workflowActivity :methods='type' :updateAction="updateData" :user="this.user" :clearModal="clearModal" :listenStateStatus="this.listenStateStatus" @refleshData="getActivities('emitter')" :users="this.users" @change="changeParent($event)" @closeBtn="closeButton()" @closeBtnActivity="closeButtonActivity($event)"></workflowActivity>
                    </div>
                    <!-- Fırsat Oluştur -->
                    <div v-else-if="showDealSection">
                        <workflow-deal :methods='type' :updateAction="updateData" :user="this.user" :users="this.users" :customFieldArray="customFields" @change="changeParent($event)" @closeBtn="closeButton()" @closeBtnDeal="closeButtonDeal($event)"></workflow-deal>
                    </div>
                    <!-- Process Oluştur -->
                    <div v-else-if="showProcessSection">
                        <workflowProcess :methods='type' :updateAction="updateData" :user="this.user" :users="this.users" :customFieldArray="customFields" @change="changeParent($event)" @closeBtn="closeButton()" @closeBtnDeal="closeButtonDeal($event)"/>
                    </div>
                </div>
            </div>
        </div>
        <!-- Delete Workflow Modal -->
        <div class="modal fade h-100" id="deleteWorkflowID" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content px-2 py-3 bg-white">
                    <div class="modal-body text-center">
                        <i class="far fa-trash-alt fa-3x" style="background: #FF0000; color: #fff; padding: 1.5rem; border-radius: 50%;"></i>
                        <h2 class="my-3" style="color:#47495A;">İş Akışını Sil</h2>
                        <p style="color: #53565E; font-size: 16px;">
                            İş akışı <strong>{{ workflowNamePart }} </strong> silinecek.Onaylıyor musunuz?
                        </p>
                    </div>
                    <div class="modal-footer d-flex align-items-center justify-content-center">
                        <button type="button" class="btn bg-transparent btn-lg mr-2" style="font-weight: 500; font-size: 16px;" data-dismiss="modal">{{$ml.get('CANCEL')}}</button>
                        <button type="button" class="btn btn-lg" style="background: #FF0000; color: #fff; font-weight: 600; font-size: 16px;" data-dismiss="modal" @click="confirmDeleteWorkflowSection">{{$ml.get('YES')}}</button>
                    </div>
                </div>
            </div>
        </div>
        <notifications group="foo" style="margin-right:5%;margin-top:5%" position="top right" />
    </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import workflowActivity from './workflowActivity.vue'
import workflowDeal from './workflowDeal.vue'
import workflowProcess from './workflowProcess.vue'
import { mapState } from 'vuex'
import {mapActions} from 'vuex'
import {mapGetters} from 'vuex'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import mqBuilderWorkflow from "../components/mongoQueryBuilder/main-area-workflow.vue"
import Grid from './Grid'
import GridMobil from "./gridMobil"
Vue.component('vue-ctk-date-time-picker', VueCtkDateTimePicker)
export default {
    components: {
        "workflowActivity":workflowActivity,
        "workflowDeal":workflowDeal,
        "workflowProcess":workflowProcess,
        mqBuilderWorkflow,
        Grid,
        GridMobil,
    },
    name:'workflowManagement',
    data (){
        return {
            contacts:[],
            customFields:[],
            gridColumns: [
                {prop:'_id',name:"Id"},
                {prop:"cuid", name: this.$ml.get('CREATED_BY'), type: "user", default:true },
                {prop:'friendlyName', name: this.$ml.get('NAME_V2'), type: "friendlyName", default:true},
                {prop:'module', name: this.$ml.get('RELATED_MODULE'), type:"module",default:true},
                {prop:'triggeredOn', name: this.$ml.get('TRIGGEREDBY'), type:"triggeredOn", default:true},
                {prop:'status', name: this.$ml.get('STATUS'), type:"status", default:true},
                {prop:'date_created', name: this.$ml.get('CREATION_DATE'),type: "dateObj", default:true},
                {prop:'date_updated', name: this.$ml.get('UPDATE_DATE'),type: "date_updated", default:true,}
            ],
            gridData:[],
            pagingSize:30,
            pagingOffset:0,
            totalCount:0,
            bottom:false,
            user:[],
            users:[],
            filter:"",
            clearModal:false,
            pageIs:"workflowManagement",
            permissions:[],
            tableConfigVisible:[],
            sort:null,
            sortType:null,
            contactsRow:[],
            contactData:[],
            isEditMode:false,
            firstLoad:true,
            checkedRows:[],
            checkAllRows:false,
            exportLang:"",
            //
            arr: [],
            showWorkflowList: true,
            setWorkflowRulesSection: {},
            relatedModule: '',
            ruleName: '',
            description: '',
            whenWillTheWorkflowStart: {},
            picked: '',
            whenWillTheWorkflowStartSection: {},
            pickedCondition: {},
            actionDetails: {},
            actionName: '',
            actionMethodSelection: '',
            showActionSection: true,
            activitySection: {},
            activitySubject: '',
            activityNote: '',
            actionSummary: false,
            showActivitySection: false,
            showDealSection: false,
            showProcessSection:false,
            showInstantSection: false,
            showPlannedDateSection: false,
            actionMethodSection: false,
            pickedActionRadioBtn: null,
            fromDecidedDateSectionChecker: true,
            decideDateHourSectionChecker: true,
            radioModuleChecker: true,
            activityDateAction: "",
            activityTimeAction: "",
            builderDateAction: "",
            actionRelatedModule: "",
            delayDay: "",
            delayHour: "",
            delayMinute: "",
            
            activities:{},
            customFields:[],
            type:'save',
            user:[],
            users:[],
            clearModal:false,
            roleId:"",
            permissions:[],
            activitiesRaw:[],
            firstLoad:true,
            objectModel: {},
            workflowArr: [],
            deleteWorkflowForm: null,
            workflowNamePart: "",
            // Özet kısmı için oluşturuldu
            create_activity_val: '',
            activityDateAction_val: '',
            // Kontroller için
            dateChecker: false,
            minuteHourDayChecker: false,
            setWorkflowPage: true,
            isUpdateMode:false,
            updateWorkflowItem:{},
            updateData:{},
            radioInstant:"",
            radioScheduled:"",
            updatedWorkflowID:""
        }
    },
    computed:{
        ...mapState([
            'baseUrl',
            'editLine',
            'editLineStatu',
            'windowWidth',
            'maxMobilSize',
            'maxTabletSize'
        ]),
        ...mapGetters(['localeLang']),
        listenState() { return this.$store.state.editLine },
        listenStateStatus() { return this.$store.state.editLineStatu }
    },
    methods:{
        ...mapActions([
            'create',
            'updateLoading',
        ]),
        deleteWorkflowSection(index){
            $('#deleteWorkflowID').modal("show");
            let form = {}
            this.workflowNamePart = this.workflowArr[index].friendlyName
            form = {
                id: this.workflowArr[index]._id.$oid
            }
            this.deleteWorkflowForm = form
            
        },  
        confirmDeleteWorkflowSection(){
            axios({
                method:'POST',
                url:'/deleteWorkflow',
                data: this.deleteWorkflowForm,
                baseURL: this.baseUrl,
                withCredentials:true
            }).then((res)=>{
                    return res
            }).then((res)=>{
                if(res.data.status.code==0){
                    this.getWorkflows()
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('SUCCESS'),
                        text: res.data.status.desc 
                    })
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                }
            })
        },
        getContactData(contactId){
            this.isUpdateMode=true
            let updateObj

            for(let item in this.workflowArr){
                if(contactId==this.workflowArr[item]._id.$oid){
                    updateObj=this.workflowArr[item]
                    this.updateWorkflowItem=this.workflowArr[item]
                }
            }

            // console.log(updateObj); 
            // console.log("******************************");
            this.updateData=updateObj.actionDetails
            this.relatedModule=updateObj.module
            this.ruleName=updateObj.friendlyName
            this.description=updateObj.detail
            this.picked=updateObj.triggeredOn
            this.pickedCondition=updateObj.workflowPrecondition
            
            this.updatedWorkflowID=updateObj._id.$oid
            // console.log(this.updatedWorkflowID);
            if(updateObj.actionDetails.actionType==='create_activity'){
                this.create_activity_val=this.$ml.get('CREATE_ACTIVITY')
                this.actionMethodSelection=updateObj.actionDetails.actionType
                this.activitySubject=updateObj.actionDetails.activityInputObj
            }
            else if(updateObj.actionDetails.actionType==='create_deal'){
                this.create_activity_val=this.$ml.get('CREATE_DEAL')
                this.actionMethodSelection=updateObj.actionDetails.actionType
                this.activitySubject=updateObj.actionDetails.dealInputObj
            }
            else if(updateObj.actionDetails.actionType==='create_process'){
                this.create_activity_val=this.$ml.get('CREATE_PROCESS')
                this.actionMethodSelection=updateObj.actionDetails.actionType
                this.activitySubject=updateObj.actionDetails.processInputObj
            }
          
            this.actionName=updateObj.actionDetails.name
            
            
            if(!updateObj.actionDetails.delay){
                this.radioInstant=1
                this.instantBtn()
            }
            else{
                this.radioScheduled=2
                this.plannedDateBtn()
            }

            this.showWorkflowList=false
            this.actionSummary=true     
        },
        getSortedData(form){
            this.sort=form.sort
            this.sortType=form.sortType
            if(form.sort === 'date_updated'){
                // console.log('sort --> ' + this.sort)
                // console.log('sortType --> ' + this.sortType)
                // console.log('form --> ' + form.sort)
                this.getWorkflows('emitter')
            }
        },
        getWorkflows(emitter){
            if(this.windowWidth<this.maxMobilSize){
                this.gridColumns= [
                    {prop:'_id',name:"Id"},
                    {prop:'module',label:this.$ml.get('RELATED_MODULE'), default:true},
                    {prop:'triggeredOn',label:this.$ml.get('NAME'), default:true},
                ]
            }  
            if(emitter!==undefined){
                this.pagingOffset=0
                if(screen.height>720){
                    this.pagingSize=30
                }else{
                    this.pagingSize=30
                }
            }
            var params = {}
            params.pagingSize=this.pagingSize
            params.pagingOffset=this.pagingOffset
            params.filter=this.filter
            if(this.sort!=null){
                params.sort=this.sort
            }
            if(this.sortType!=null){
                params.sortType=this.sortType
            }
            axios({
                method:'POST',
                url:'/workflowList',
                baseURL: this.baseUrl,
                data: params,
                withCredentials:true
            }).then((res)=>{
                    return res
            }).then((res)=>{
                if(!res.data.status){
                    // this.$router.push('/logout')
                }
                    if(emitter!==undefined){
                        this.contacts=[]
                        this.contactsRow=[]
                    }
                    
                    if(this.firstLoad){
                        for(var col in this.gridColumns){
                            if(this.gridColumns[col]['default']){
                                this.tableConfigVisible.push(this.gridColumns[col]['prop'])
                            }
                        }
                    }
                    
                    this.firstLoad=false
                    if(res.data.workflows){
                        var workflowList = []
                        let columns =this.gridColumns
                        for (var contactObjIter in res.data.workflows){
                            this.contactsRow.push(res.data.workflows[contactObjIter])
                            let obj={}
                            let contactObj =res.data.workflows[contactObjIter]
 
                              
                            for(var column in columns){
                                var colInActivity = contactObj.hasOwnProperty(columns[column]['prop'])
                                if(colInActivity){
                                    
                                    let edObj={}
                                    
                                    edObj['val']=contactObj[columns[column]['prop']]
                                    
                                    edObj['isEditMode']=false
                                    edObj['type']=columns[column]['type']
                                    obj[columns[column]['prop']]=edObj
                                }else{
                                    let edObj={}
                                    edObj['val']=null
                                    edObj['isEditMode']=false
                                    edObj['type']=columns[column]['type']
                                    if(columns[column]['type']=='price'){
                                        let pricesList = []
                                        let priceObj = {}
                                        priceObj['currency']=null
                                        priceObj['price']=null
                                        pricesList.push(priceObj)
                                        edObj['val']=pricesList
                                    }else if(columns[column]['type']==4){
                                        let oid = {} 
                                        oid['$oid']=''
                                        edObj['val']={}
                                        edObj['val']['_id']=oid
                                    }else if(columns[column]['type']=='dateObj'){
                                        let date = {}
                                        date['$date']=''
                                        edObj['val']=date
                                    }else if(columns[column]['type']==5){
                                        let priceObj = {}
                                        priceObj['currency']=''
                                        priceObj['value']=''
                                        edObj['val']=priceObj
                                    }else if(columns[column]['type']==6){
                                        let selected = ""
                                        edObj['val']=selected
                                    }else if(columns[column]['type']==7){
                                        let optionsList = []
                                        edObj['val']=optionsList
                                    }else if(columns[column]['type']=='country'){
                                        edObj['val']=''
                                    }
                                    obj[columns[column]['prop']]=edObj
                                }
                            }
                            workflowList.push(obj)
                            
                        }
                        this.gridData = workflowList
                        workflowList.reverse()
                        this.workflowArr = res.data.workflows.reverse()
                    }
                    	this.user=res.data.user
                        this.users=res.data.users
                        this.permissions=res.data.permissions
            })
        },
        cancelAction(){
            this.actionName = ''
            this.delayMinute = ''
            this.delayHour = ''
            this.delayDay = ''
            this.actionRelatedModule = ''
            this.fromDecidedDateSectionChecker = true
            this.decideDateHourSectionChecker = true
            this.radioModuleChecker = true
            this.actionMethodSelection = ''
            this.pickedActionRadioBtn = null
            this.showInstantSection=false
            this.showPlannedDateSection=false
            this.actionMethodSection=false
        },
        deleteAction(){
            setTimeout(() => {
                this.actionSummary= false
            }, 100);
            this.actionName = ''
            this.delayMinute = ''
            this.delayHour = ''
            this.delayDay = ''
            this.actionRelatedModule = ''
            this.fromDecidedDateSectionChecker = true
            this.decideDateHourSectionChecker = true
            this.radioModuleChecker = true
            this.actionMethodSelection = ''
            this.pickedActionRadioBtn = null
            this.showInstantSection=false
            this.showPlannedDateSection=false
            this.actionMethodSection=false
            this.closeButton()
            $('#saveBtn').attr('disabled', 'disabled');
        },
        createF() {
            let pickedConditionObject = {}

            if(this.pickedCondition == 'applyWithoutCondition'){
                pickedConditionObject = '{"==":[1,1]}'
            }else{
                pickedConditionObject = this.pickedCondition
            }
            let date = {}
            let emptyDate = ''
            let form = {}
            let delayCheck
            let emptyDateCheck
            if((this.activityDateAction == '' && this.activityTimeAction == '') && (this.delayDay == '' && this.delayHour == '' && this.delayMinute == '') && (this.actionRelatedModule == '')){
                emptyDateCheck = true
                date = emptyDate
            }else if(this.delayDay != '' && this.delayHour != '' && this.delayMinute != ''){
                const day = Math.floor(this.delayDay * 1440);
                const hour = Math.floor(this.delayHour * 60);
                const minute = Math.floor(this.delayMinute);
                date = day + hour + minute
                delayCheck = true
            }else{
                if(this.activityDateAction != '' && this.activityTimeAction != ''){
                    const activityDateActionVal = new Date(this.activityDateAction)
                    const mainWorkflowDate = moment(activityDateActionVal).format('DD MMMM YYYY')
                    const dateString = mainWorkflowDate.concat(' ', this.activityTimeAction)
                    const event = new Date(dateString);
                    const dueDateString = event.toISOString()
           
                    date = {
                        $date: dueDateString
                    }
                }
                
                delayCheck = false
            }
                        
            form.FriendlyName = this.ruleName
            form.Detail = this.description
            form.Module = this.relatedModule
            form.TriggeredOn = this.picked
            form.WorkflowPrecondition = pickedConditionObject
            if(this.actionMethodSelection==="create_deal"){
                form.ActionDetails = {
                    name: this.actionName,
                    actionType: this.actionMethodSelection,
                    dealInputObj: this.activitySubject
                }
            }
            if(this.actionMethodSelection==="create_activity"){
                form.ActionDetails = {
                    name: this.actionName,
                    actionType: this.actionMethodSelection,
                    activityInputObj: this.activitySubject
                }
            }
            if(this.actionMethodSelection==="create_process"){
                form.ActionDetails = {
                    name: this.actionName,
                    actionType: this.actionMethodSelection,
                    processInputObj: this.activitySubject
                }
            }
            
            console.log(form);
            if(delayCheck == true){
                Object.assign(form.ActionDetails, { delay: date });
            }else{
                if((this.activityDateAction != '' && this.activityTimeAction != '')){
                    Object.assign(form.ActionDetails, { delay_date_for_rindap: date });
                }else if(!emptyDateCheck){
                    Object.assign(form.ActionDetails, { delay_field: this.actionRelatedModule });
                }
            }
            console.log('Create İÇİ')
            console.log(form)
           
            axios({
                method:'POST',
                url:'/createWorkflow',
                baseURL: this.baseUrl,
                data: form,
                withCredentials:true
                }).then((res)=>{
                    return res
                    
                }).then((res)=>{
                if(res.data.status.code==0){
                    this.getWorkflows()
                    this.$notify({ 
                        group: 'foo',
                        type: 'success',
                        delay:6000,
                        title: this.$ml.get('SUCCESSFUL'),
                        text: res.data.status.desc 
                    })
                }else{
                    // console.log("-----------------------");
                    // console.log(res);
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                }
            })
            
            this.showWorkflowList = true
            this.showActionSection = true
            this.showDealSection = false
            this.showActivitySection = false
            this.showProcessSection = false
            this.$emit('setWorkflowSection',this.setWorkflowPage)
        },

        updateF(){
            let pickedConditionObject = {}

            if(this.pickedCondition == 'applyWithoutCondition'){
                pickedConditionObject = '{"==":[1,1]}'
            }else{
                pickedConditionObject = this.pickedCondition
            }
            let date = {}
            let emptyDate = ''
            let form = {}
            let delayCheck
            let emptyDateCheck
            if((this.activityDateAction == '' && this.activityTimeAction == '') && (this.delayDay == '' && this.delayHour == '' && this.delayMinute == '') && (this.actionRelatedModule == '')){
                emptyDateCheck = true
                date = emptyDate
            }else if(this.delayDay != '' && this.delayHour != '' && this.delayMinute != ''){
                const day = Math.floor(this.delayDay * 1440);
                const hour = Math.floor(this.delayHour * 60);
                const minute = Math.floor(this.delayMinute);
                date = day + hour + minute
                delayCheck = true
            }else{
                if(this.activityDateAction != '' && this.activityTimeAction != ''){
                    const activityDateActionVal = new Date(this.activityDateAction)
                    const mainWorkflowDate = moment(activityDateActionVal).format('DD MMMM YYYY')
                    const dateString = mainWorkflowDate.concat(' ', this.activityTimeAction)
                    const event = new Date(dateString);
                    const dueDateString = event.toISOString()
           
                    date = {
                        $date: dueDateString
                    }
                }
                
                delayCheck = false
            }
            
            // console.log("CREATE İÇİ");
            
            form.FriendlyName = this.ruleName
            form.Detail = this.description
            form.Module = this.relatedModule
            form.TriggeredOn = this.picked
            form.WorkflowPrecondition = pickedConditionObject
            if(this.actionMethodSelection==="create_deal"){
                form.ActionDetails = {
                    name: this.actionName,
                    actionType: this.actionMethodSelection,
                    dealInputObj: this.activitySubject
                }
            }
            if(this.actionMethodSelection==="create_activity"){
                form.ActionDetails = {
                    name: this.actionName,
                    actionType: this.actionMethodSelection,
                    activityInputObj: this.activitySubject
                }
            }
            if(this.actionMethodSelection==="create_process"){
                form.ActionDetails = {
                    name: this.actionName,
                    actionType: this.actionMethodSelection,
                    processInputObj: this.activitySubject
                }
            }
            
            form.sid = this.updatedWorkflowID
            // console.log(form);
            if(delayCheck == true){
                Object.assign(form.ActionDetails, { delay: date });
            }else{
                if((this.activityDateAction != '' && this.activityTimeAction != '')){
                    Object.assign(form.ActionDetails, { delay_date_for_rindap: date });
                }else if(!emptyDateCheck){
                    Object.assign(form.ActionDetails, { delay_field: this.actionRelatedModule });
                }
            }
           
            axios({
                method:'POST',
                url:'/updateWorkflow',
                baseURL: this.baseUrl,
                data: form,
                withCredentials:true
                }).then((res)=>{
                    return res
                    
                }).then((res)=>{
                if(res.data.status.code==0){
                    this.getWorkflows()
                    this.$notify({ 
                        group: 'foo',
                        type: 'success',
                        delay:6000,
                        title: this.$ml.get('SUCCESSFUL'),
                        text: res.data.status.desc 
                    })
                }else{
                    this.getWorkflows()
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                }
            })
            
            this.showWorkflowList = true
            this.showActionSection = true
            this.showDealSection = false
            this.showProcessSection = false
            this.showActivitySection = false
        },

        ChangeT(title){
            this.title=title;
        },
        dependentOnTheForthArea(){
            $('#decideActionSection').css({'pointer-events': 'auto', 'opacity': '1'})
        },
        searchInput(item){
            // console.log("İTEM");
            // console.log(item);
            this.pickedCondition = item
        },
        changeParent(subject){
            this.activitySubject=subject;
            $('#saveBtn').removeAttr('disabled');
        },
        closeButton(){
            this.showActivitySection = false
            this.showDealSection = false
            this.showProcessSection = false
            this.showActionSection = true
        },
        closeButtonActivity(closeActivity){
            this.showActivitySection = true
            this.actionSummary = true
        },
        closeButtonDeal(){
            this.showDealSection = false
            this.actionSummary = true
        },
        
        updateRelatedModule(){
            this.$refs.mqBuilder.setObjectModel(this.relatedModule, 'refreshSelectedSearch')
        },
        addElem(){
            this.$refs.mqBuilder.addElem()
        },
        newWorkflowBtn(){
            this.isUpdateMode=false
            this.showWorkflowList = false
            this.updateWorkflowItem = ''
            this.updateData = ''
            this.relatedModule = ''
            this.ruleName = ''
            this.description = ''
            this.picked = ''
            this.pickedCondition = ''
            this.actionSummary= false
            this.pickedActionRadioBtn = null
            this.fromDecidedDateSectionChecker = true
            this.decideDateHourSectionChecker = true
            this.radioModuleChecker = true
            this.actionName = ''
            this.delayMinute = ''
            this.delayHour = ''
            this.delayDay = ''
            this.actionRelatedModule = ''
            this.activityDateAction= ""
            this.activityTimeAction= ""
            this.actionMethodSelection= ''
            this.showInstantSection=false
            this.showPlannedDateSection=false
            this.actionMethodSection=false
            this.showActionSection = true
        },
        goBackToWorkflowListBtn(){
            this.showWorkflowList = true
        },
        nextToStep2(){
            if(this.relatedModule === '' || this.relatedModule === undefined){
                this.$notify({ 
                    group: 'foo',
                    type: 'warn', 
                    title: this.$ml.get('WARNING'),
                    text: this.$ml.get('PLEASE_SELECT_A_MODULE')
                })
                return false
            }

            if(this.ruleName === ''){
                this.$notify({ 
                    group: 'foo',
                    type: 'warn', 
                    title: this.$ml.get('WARNING'),
                    text: this.$ml.get('PLEASE_ENTER_A_RULENAME')
                })
                return false
            }
            else{
                if(this.isUpdateMode!==true){
                    for(let item of this.workflowArr){
                        if(item.friendlyName===this.ruleName){
                            this.$notify({ 
                                group: 'foo',
                                type: 'warn', 
                                title: this.$ml.get('WARNING'),
                                text: 'Bu kural ismi daha önce kullanılmış'
                            })
                            return false
                        }
                    }
                }
                
            }
            
            $('#relatedModule').attr('disabled', 'disabled'); 
            $('#proceedToStep2Btn').attr('disabled', 'disabled'); 
            $('#whenWillTheWorkflowStartcollapse').removeClass("collapse");
            $('#howWillTheWorkflowWorkcollapse').removeClass("collapse");
            $('#decideActioncollapse').removeClass("collapse");
            $('#whenWillTheWorkflowStartSection').css({'pointer-events': 'auto', 'opacity': '1'})
            $('#howWillTheWorkflowWorkSection').css({'pointer-events': 'none', 'opacity': '0.5'})
            $('#decideActionSection').css({'pointer-events': 'none', 'opacity': '0.5'})
            $("input:radio").change(function () {
                if ($('#create').val() === "create") {
                    $('#howWillTheWorkflowWorkSection').css({'pointer-events': 'auto', 'opacity': '1'})
                }
            });
            $('#setCondition').on('click', function(){
                $('#decideActionSection').css({'pointer-events': 'none', 'opacity': '0.5'})
                $('#mqBuilderWorkflow').show()
                
            })
            $('#applyWithoutCondition').on('click', function(){
                $('#decideActionSection').css({'pointer-events': 'auto', 'opacity': '1'})
                $('#mqBuilderWorkflow').hide()
            })
            if(this.isUpdateMode==true){
                this.updateRelatedModule()
                if(this.picked!==null){
                    $('#howWillTheWorkflowWorkSection').css({'pointer-events': 'auto', 'opacity': '1'})
                }
                if(this.pickedCondition==='{"==":[1,1]}'){
                    this.pickedCondition='applyWithoutCondition'
                    $('#decideActionSection').css({'pointer-events': 'auto', 'opacity': '1'})
                }
                else{
                    this.pickedCondition='setCondition'
                    $('#mqBuilderWorkflow').show()
                    $('#decideActionSection').css({'pointer-events': 'auto', 'opacity': '1'})
                }
            }
        },
        fromDecidedDateSection(){
            // console.log('fromDecidedDateSection')
            this.dateChecker = false
            this.decideDateHourSectionChecker = false
            this.radioModuleChecker = false
            $('#fromDecidedDateSectionID').css('pointer-events', 'auto')
        },
        decideDateHourSection(){
            // console.log('decideDateHourSection')
            this.minuteHourDayChecker = false
            this.fromDecidedDateSectionChecker = false
            this.radioModuleChecker = false
            $('#decideDateHourSectionID').css('pointer-events', 'auto')
        },
        radioModuleSection(){
            // console.log('radioModuleSection')
            this.dateChecker = false
            this.minuteHourDayChecker = false
            this.fromDecidedDateSectionChecker = false
            this.decideDateHourSectionChecker = false
            $('#radioModuleSectionID').css('pointer-events', 'auto')
        },
        instantBtn(){
            this.showInstantSection = true
            this.showPlannedDateSection = false
            this.actionMethodSection = true
            this.fromDecidedDateSectionChecker = false
            this.decideDateHourSectionChecker = false
            this.radioModuleChecker = false
            this.activityDateAction = ''
            this.activityTimeAction = ''
            this.delayMinute = ''
            this.delayHour = ''
            this.delayDay = ''
            this.dateChecker = false
            this.minuteHourDayChecker = false
            
        },
        plannedDateBtn(){
            this.showInstantSection = false
            this.showPlannedDateSection = true
            this.actionMethodSection = true
            this.fromDecidedDateSectionChecker = true
            this.decideDateHourSectionChecker = true
            this.radioModuleChecker = true
            this.dateChecker = true
            this.minuteHourDayChecker = true
        },
        nextToActionMethod(){
            if(this.actionName === ''){
                this.$notify({ 
                    group: 'foo',
                    type: 'warn', 
                    title: this.$ml.get('WARNING'),
                    text: this.$ml.get('PLEASE_ENTER_AN_ACTION_NAME')
                })
                return false
            }
            if(this.fromDecidedDateSectionChecker === true && this.decideDateHourSectionChecker === true && this.radioModuleChecker === true){
                this.$notify({ 
                        group: 'foo',
                        type: 'warn', 
                        title: this.$ml.get('WARNING'),
                        text: this.$ml.get('PLEASE_CHOOSE_AN_OPTION')
                    })
                    return false
            }else{
                if(this.minuteHourDayChecker === true){
    
                    if(this.delayDay == ""){
                        this.$notify({ 
                            group: 'foo',
                            type: 'warn', 
                            title: this.$ml.get('WARNING'),
                            text: this.$ml.get('PLEASE_ENTER_THE_DAY')
                        })
    
                        return false
                    }
    
                    if(this.delayHour == ""){
                        this.$notify({ 
                            group: 'foo',
                            type: 'warn', 
                            title: this.$ml.get('WARNING'),
                            text: this.$ml.get('PLEASE_ENTER_THE_HOUR')
                        })
    
                        return false
                    }
    
                    if(this.delayMinute == ""){
                        this.$notify({ 
                            group: 'foo',
                            type: 'warn', 
                            title: this.$ml.get('WARNING'),
                            text: this.$ml.get('PLEASE_ENTER_THE_MINUTE')
                        })
    
                        return false
                    }
                    
                }
    
                if(this.dateChecker === true ){
    
                    if(this.activityDateAction == "" || this.activityDateAction == undefined || this.activityDateAction == null){
                        this.$notify({ 
                            group: 'foo',
                            type: 'warn', 
                            title: this.$ml.get('WARNING'),
                            text: this.$ml.get('PLEASE_ENTER_THE_DATE')
                        })
    
                        return false
                    }
    
                    if(this.activityTimeAction == "" || this.activityTimeAction == undefined || this.activityTimeAction == null){
                        this.$notify({ 
                            group: 'foo',
                            type: 'warn', 
                            title: this.$ml.get('WARNING'),
                            text: this.$ml.get('PLEASE_ENTER_THE_TIME')
                        })
    
                        return false
                    }
                }
                if(this.radioModuleChecker === true){
                    if(this.actionRelatedModule == "" || this.actionRelatedModule == undefined || this.actionRelatedModule == null){
                        this.$notify({ 
                            group: 'foo',
                            type: 'warn', 
                            title: this.$ml.get('WARNING'),
                            text: this.$ml.get('PLEASE_CHOOSE_AN_OPTION_V2')
                        })
    
                        return false
                    }
                }
            }
            
            if(this.actionMethodSelection === 'create_activity'){
                this.create_activity_val = this.$ml.get('CREATE_ACTIVITY')
                
                if(this.activityDateAction != ''){
                    this.activityDateAction_val = moment(this.activityDateAction).format('DD/MM/YYYY').concat(' - ', this.activityTimeAction);
                }else{
                    this.activityDateAction_val == ''
                }
            
                this.showActionSection = false
                this.showActivitySection = true
            }else if(this.actionMethodSelection === 'create_deal'){
                this.create_activity_val = this.$ml.get('CREATE_DEAL')
                this.showActionSection = false
                this.showDealSection = true
            }else if(this.actionMethodSelection === 'create_process'){
                this.create_activity_val = this.$ml.get('CREATE_PROCESS')
                this.showActionSection = false
                this.showDealSection = false
                this.showProcessSection = true
            }else{
                this.$notify({ 
                    group: 'foo',
                    type: 'warn', 
                    title: this.$ml.get('WARNING'),
                    text: this.$ml.get('PLEASE_SELECT_AN_ACTION_METHOD')
                })
                return false
            }
            this.isActive()
        },
        isActive(){
            axios({
                method:'POST',
                url:'/getUsers',
                baseURL: this.baseUrl,
                data: {
                    showPassiveUsers:true
                },
                withCredentials:true
                }).then((res)=>{
                    return res
                }).then((res)=>{
                if(res.data.status){
                    if(res.data.status.code==0){
                        this.user=res.data.content.user
                        this.users=res.data.content.users
                    }else{
                    }
                }else{
                    this.$router.go(-1)
                }
            })
        },
        modalHidden(){
            let statu=false
            this.$store.dispatch('editLineStatu', statu)
            this.clearModal=true
            
        },
        
        
    },
    created(){
        if(localStorage.roleId!==undefined){
            this.roleId=localStorage.roleId
        }else{
            this.roleId="2"
        }
    },
    
    mounted(){
        this.getWorkflows()
        $(this.$refs.vuemodal).on("hidden.bs.modal", this.modalHidden)
        if(this.decideDateValueBtn){
            // console.log(this.decideDateValueBtn + ' ' + this.decideDate + ' ' + this.decideHour)
        }
        if(screen.height>720){
            this.pagingSize=30
        }else{
            this.pagingSize=30
        }
        if(this.$ml.current=="en"){
            this.exportLang="eng"
        }
        else{
            this.exportLang="tur"
        }
    },
        
    watch:{
        bottom(bottom) {
            if (bottom) {
                    this.pagingOffset+=this.pagingSize
            }
        },
        permissions:function(){
            if(this.permissions===undefined){
                this.permissions=[]
            }
        }
    }
}
</script>
<style scoped>
    .modal .animation-content .modal-card {
        overflow: visible !important;
    }
    .modal-card-body {
        overflow: visible !important;
    }
    .modal-section{
        background-color:#D7E3F4;
    }
    .modal-section li {
        font-size: 14px;
        margin-right: 5px;
    }
    .modal-section li a {
        color: #93959A;
        text-decoration: none;
        height: 100%;
        display: flex;
        align-items: center;
        padding: 0 13px;
    }
    .modal-section li a.active {
        color: #5b5f63;
        font-weight: bold;
        border-bottom: 3px solid #1991EB;
    }
    .card-header-section{
        position: relative;
        height: 51px;
        display: flex;
        align-items: center;
    }
    .card-header-section .card-number{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        font-size: 19px;
        background: #747474;
        color: #fff;
        width: 34px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        border-top-left-radius: 3px;
    }
    .card-header-section .card-header-text{
        color: #53565E;
        font-size: 15.5px;
    }
    .radio-btn-groups-wrapper {
        clear: both;
        display: inline-block;
    }
    .radio-btn-group {
        position: absolute;
        left: -9999em;
        top: -9999em;
    }
    .radio-btn-group + label {
        float: left;
        padding: 0.55em 1em;
        cursor: pointer;
        border: 1px solid #183C58;
        margin-right: -1px;
        color: #fff;
        background-color: #183C58;
;
    }
    .radio-btn-group + label:first-of-type {
        border-radius: 4px 0 0 4px;
    }
    .radio-btn-group + label:last-of-type {
        border-radius: 0 4px 4px 0;
    }
    .radio-btn-group:checked + label {
        background-color: #051E31;
    }
    .actionSummaryList{
        list-style-type: none;
        padding: 0;
        margin: 0;
    }
    .actionSummaryList li{
        color: #162C4D;
        font-size: 15px;
        font-weight: 400;
        margin-bottom: 0.3rem;
    }
    .actionSummaryList li span{
        font-weight: 500;
    }
    .summaryIcons .fa-pen{
        background: #3767A0;
        padding: 0.75rem 0.9rem;
        border-radius: 4px;
        margin-right: 0.1rem;
        cursor: pointer;
    }
    .summaryIcons .fa-trash{
        background: #FF0000;
        padding: 0.75rem 0.9rem;
        border-radius: 4px;
        cursor: pointer;
    }
    .summaryIcons i{
        font-size: 1rem;
        color: #fff;
    }
</style>
